import React, { useRef } from "react";
import { CalendarDays } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function coerceCareDate(value, precision) {
  const text = String(value || "").trim();
  if (!text) return "";
  if (precision === "year") {
    return /^\d{4}$/.test(text.slice(0, 4)) ? text.slice(0, 4) : "";
  }
  if (precision === "month") {
    const month = text.slice(0, 7);
    return /^\d{4}-\d{2}$/.test(month) ? month : "";
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return text;
  if (/^\d{4}-\d{2}$/.test(text)) return `${text}-01`;
  if (/^\d{4}$/.test(text)) return `${text}-01-01`;
  return "";
}

export default function CareDateField({ precision, value, onChange, testId }) {
  const { t } = useLanguage();
  const inputRef = useRef(null);
  const inputType = precision === "month" ? "month" : precision === "year" ? "number" : "date";
  const openCalendar = () => {
    const input = inputRef.current;
    if (!input) return;
    if (typeof input.showPicker !== "function") {
      input.focus();
      return;
    }
    try {
      input.showPicker();
    } catch {
      input.focus();
    }
  };
  return (
    <div className="flex gap-2">
      <Input
        ref={inputRef}
        type={inputType}
        value={value}
        min={precision === "year" ? "1900" : undefined}
        max={precision === "year" ? "2100" : undefined}
        onChange={(event) => onChange(event.target.value)}
        data-testid={testId}
        className="min-w-0 flex-1"
      />
      {inputType !== "number" && (
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-9 w-9 shrink-0"
          aria-label={t("history.eventDate")}
          onClick={openCalendar}
          data-testid={testId ? `${testId}-calendar` : undefined}
        >
          <CalendarDays className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
